(function (host) {
  'use strict';
  const own = i => ['shared-preview','bader-preview'].includes(i.properties?._loshen_auto_gwp);
  const gift = (i,data) => own(i) || data.giftIds.map(String).includes(String(i.product_id)) || !!i.properties?._loshen_gwp || /^(gwp|gift with purchase|cadeau avec achat)$/i.test(i.product_type || '');
  const signature = lines => lines.map(i => `${i.variant_id ?? i.id}:${i.quantity}:${i.final_line_price ?? i.price}`).join('|');
  const conflict = cart => (cart.discount_codes || []).some(d => d.applicable !== false) || (cart.cart_level_discount_applications || []).length > 0 || cart.items.some(i => !own(i) && (i.final_line_price < i.original_line_price || (i.line_level_discount_allocations || []).some(a => Number(a.amount) > 0)));
  function select(cart,data,now=Date.now()) {
    if(cart.currency!=='CAD' || data.currency!=='CAD' || signature(cart.items)!==signature(data.lines)) return {status:'changed'};
    if(conflict(cart) || cart.items.some(i=>!own(i)&&gift(i,data))) return {status:'other-offer'};
    const eligible=data.rules.filter(r=>!r.code && (!Number(r.starts)||now>=Number(r.starts)*1000) && (!Number(r.ends)||now<Number(r.ends)*1000)).filter(r=>{
      const paid=cart.items.filter(i=>!gift(i,data)&&!i.gift_card&&i.final_line_price>0&&r.matches.map(String).includes(String(i.variant_id)));
      return paid.length && paid.reduce((s,i)=>s+i.final_line_price,0)>=r.minimum && paid.reduce((s,i)=>s+i.quantity,0)>=r.quantity;
    }).sort((a,b)=>a.priority-b.priority || (a.group===b.group ? b.minimum-a.minimum || b.quantity-a.quantity : a.offer.localeCompare(b.offer)));
    if(!eligible.length)return {status:'not-eligible'};
    const top=eligible[0];
    const choices=eligible.filter(r=>r.group===top.group&&r.minimum===top.minimum&&r.quantity===top.quantity&&r.available);
    if(!choices.length)return {status:'sold-out'};
    if(choices.length>1)return {status:'choose-gift'};
    return {status:'eligible',rule:choices[0]};
  }
  if(typeof module!=='undefined'&&module.exports){module.exports={own,gift,signature,conflict,select};return;}
  if(host.loshenGwpPilot)return;
  const config=document.getElementById('loshen-gwp-pilot-config');if(!config)return;
  const root=host.Shopify?.routes?.root||'/';
  let state=null;
  let busy=false,queued=false,timer,changed=false,failed='',lastOwned=false,flight=null;
  let suppressed='',lastOwnedSignature='';try{suppressed=sessionStorage.getItem('loshen-gwp-suppressed')||'';lastOwnedSignature=sessionStorage.getItem('loshen-gwp-last-owned')||'';failed=sessionStorage.getItem('loshen-gwp-failed')||'';}catch(_){}
  const remember=s=>{suppressed=s;try{sessionStorage.setItem('loshen-gwp-suppressed',s);}catch(_){}};
  async function request(path,data){
    const r=await fetch(root+path,{method:data?'POST':'GET',credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json',...(data?{'Content-Type':'application/json'}:{})},...(data?{body:JSON.stringify(data)}:{})});
    if(!r.ok)throw new Error(`Gift request failed: ${r.status}`);return r.json();
  }
  async function snapshot(){
    const r=await fetch(root+'cart?section_id=loshen-gwp-cart-data',{credentials:'same-origin',cache:'no-store'});
    if(!r.ok)throw new Error('Gift rules unavailable');
    const el=new DOMParser().parseFromString(await r.text(),'text/html').querySelector('[data-loshen-gwp-rules]');
    if(!el)throw new Error('Gift rules missing');return JSON.parse(el.textContent);
  }
  async function removeOwned(){
    let cart=await request('cart.js');
    for(let n=0;n<20&&cart.items.some(own);n++){
      await request('cart/change.js',{id:cart.items.find(own).key,quantity:0});changed=true;cart=await request('cart.js');
    }
    if(cart.items.some(own))throw new Error('Gift removal needs review');return cart;
  }
  function refresh(cart){document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{cart}}));if(/\/cart\/?$/.test(location.pathname))location.reload();}
  async function run(){
    if(busy){queued=true;return;}if(host.__lcnGiftClaimBusy){schedule();return;}busy=true;host.__lcnGiftClaimBusy=true;changed=false;config.dataset.status='checking';
    let cart;
    try{
      cart=await request('cart.js');let data=await snapshot(),result=select(cart,data);
      if(result.status==='changed'){cart=await request('cart.js');data=await snapshot();result=select(cart,data);if(result.status==='changed'){queued=true;return;}}
      let owned=cart.items.filter(own);const sig=signature(cart.items.filter(i=>!own(i)));
      if((lastOwned||lastOwnedSignature===sig)&&!owned.length&&result.rule)remember(sig);
      if(!result.rule)remember('');
      if(owned.length&&(!result.rule||owned.length!==1||owned[0].quantity!==1||String(owned[0].variant_id)!==String(result.rule.variant)||owned[0].final_line_price!==0)){
        cart=await removeOwned();owned=[];data=await snapshot();result=select(cart,data);
      }
      if(!owned.length&&result.rule&&suppressed!==sig&&failed!==sig){
        failed=sig;
        const rule=result.rule;
        await request('cart/add.js',{items:[{id:rule.variant,quantity:1,properties:{_loshen_auto_gwp:'shared-preview',_loshen_gwp:rule.offer}}]});changed=true;
        cart=await request('cart.js');data=await snapshot();result=select(cart,data);owned=cart.items.filter(own);
        if(!result.rule||owned.length!==1||owned[0].quantity!==1||String(owned[0].variant_id)!==String(result.rule.variant)||owned[0].final_line_price!==0){cart=await removeOwned();result={status:'not-free'};}
        else failed='';
      }
      lastOwned=cart.items.some(own);lastOwnedSignature=lastOwned?signature(cart.items.filter(i=>!own(i))):'';try{sessionStorage.setItem('loshen-gwp-last-owned',lastOwnedSignature);sessionStorage.setItem('loshen-gwp-failed',failed);}catch(_){}config.dataset.status=lastOwned?'gift-confirmed':result.status;
      state={cart,data,result,status:config.dataset.status};
      config.dataset.offer=lastOwned?cart.items.find(own).properties._loshen_gwp:'';
      delete config.dataset.error;
    }catch(error){
      config.dataset.status='needs-review';config.dataset.error=error.message;
      try{cart=await removeOwned();lastOwned=false;}catch(_){config.dataset.status='removal-needs-review';}
      console.error('Loshen gift check:',error.message);
    }finally{
      busy=false;host.__lcnGiftClaimBusy=false;
      if(state){state.status=config.dataset.status;document.dispatchEvent(new CustomEvent('loshen:gwp-state',{detail:state}));}
      if(changed&&cart)refresh(cart);if(queued){queued=false;schedule();}
    }
  }
  function reconcile(){
    if(flight){queued=true;return flight;}
    flight=run().finally(()=>{flight=null;});return flight;
  }
  function schedule(){clearTimeout(timer);timer=setTimeout(reconcile,450);}
  let checkoutPass=false;
  document.addEventListener('click',async event=>{
    const button=event.target.closest('[name="checkout"],a[href="/checkout"],a[href^="/checkout?"]');
    if(!button||checkoutPass)return;
    event.preventDefault();event.stopImmediatePropagation();
    if(flight)await flight;
    await reconcile();
    if(['checking','needs-review','removal-needs-review'].includes(config.dataset.status)){
      let message=document.getElementById('loshen-gwp-checkout-status');
      if(!message){message=document.createElement('p');message.id='loshen-gwp-checkout-status';message.setAttribute('role','status');button.after(message);}
      message.textContent=document.documentElement.lang.startsWith('fr')?'Nous vérifions votre cadeau. Veuillez réessayer dans un instant.':'We are checking your gift. Please try again in a moment.';
      return;
    }
    checkoutPass=true;button.click();checkoutPass=false;
  },true);
  host.loshenGwpPilot={check:schedule,getState:()=>state,select,retry:async variant=>{
    if(flight)await flight;
    if(busy||host.__lcnGiftClaimBusy)return false;
    const cart=await request('cart.js'),data=await snapshot(),result=select(cart,data);
    if(!result.rule||variant&&String(result.rule.variant)!==String(variant))return false;
    remember('');failed='';lastOwned=false;lastOwnedSignature='';
    try{sessionStorage.removeItem('loshen-gwp-failed');sessionStorage.removeItem('loshen-gwp-last-owned');}catch(_){}
    await reconcile();return true;
  }};
  ['cart:change','cart:updated','product:added','variant:add'].forEach(type=>document.addEventListener(type,schedule));
  host.addEventListener('pageshow',schedule);document.addEventListener('visibilitychange',()=>{if(!document.hidden)schedule();});schedule();
})(typeof window==='undefined'?globalThis:window);

